// A few JavaScript Functions for Images and Files
// Author: Justin Mitchel
// Source: https://kirr.co/ndywes

// Convert a Base64-encoded string to a File object
export function base64StringtoFile(base64String, filename) {
  let arr = base64String.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

// Download a Base64-encoded file

export function downloadBase64File(base64Data, filename) {
  let element = document.createElement('a');
  element.setAttribute('href', base64Data);
  element.setAttribute('download', filename);
  element.setAttribute('id', 'file');
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
  return true;
}

// Extract an Base64 Image's File Extension
export function extractImageFileExtensionFromBase64(base64Data) {
  return base64Data.substring(
    'data:image/'.length,
    base64Data.indexOf(';base64')
  );
}

export function formMediaFullUrl(url) {
  // Replace the scheme+host of django-supplied urls (whether already absolute
  // or relative) with mediaBaseUrl, so requests always target the host the
  // browser is actually served from rather than whatever host Django used
  // internally (e.g. the local runserver address) to build the url.
  const mediaBaseUrl = window.ENV?.mediaBaseUrl || '';
  if (!mediaBaseUrl) {
    return url;
  }
  let path = url;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    const parsed = new URL(url);
    path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
  }
  const mediaFullUrl = `${mediaBaseUrl}${path}`;
  console.log("mediaBaseUrl=" + mediaBaseUrl);
  console.log("mediaFullUrl=" + mediaFullUrl);
  return mediaFullUrl;
}

const MEDIA_CACHE_INVALIDATED_EVENT = 'media-cache-invalidated';
const mediaCacheVersionByUrl = new Map();

function appendCacheVersion(src, version) {
  if (!version) {
    return src;
  }

  const delimiter = src.includes('?') ? '&' : '?';
  return `${src}${delimiter}v=${version}`;
}

export function getMediaCacheInvalidatedEventName() {
  return MEDIA_CACHE_INVALIDATED_EVENT;
}

export function getMediaCacheVersion(url) {
  if (!url) {
    return 0;
  }

  const fullUrl = formMediaFullUrl(url);
  return mediaCacheVersionByUrl.get(fullUrl) || 0;
}

export function invalidateMediaCache(url) {
  if (!url) {
    return;
  }

  const fullUrl = formMediaFullUrl(url);
  const nextVersion = Date.now();
  mediaCacheVersionByUrl.set(fullUrl, nextVersion);

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(
      new CustomEvent(MEDIA_CACHE_INVALIDATED_EVENT, {
        detail: {
          url: fullUrl,
          version: nextVersion,
        },
      })
    );
  }
}

export function formMediaVersionedUrl(url, forceNoCache = false, cacheVersion) {
  const src = formMediaFullUrl(url);
  if (forceNoCache) {
    return appendCacheVersion(src, Date.now());
  }

  const version = cacheVersion !== undefined ? cacheVersion : getMediaCacheVersion(url);
  return appendCacheVersion(src, version);
}